import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import COLOR_THEMES, {COLORS} from "../../../colorThemes";
import SqftFeaturesPopupFeatureDropdown from "./sqftFeaturesPopupFeatureDropdown";
import SqftFeaturesPopupFeaturePrice from "./sqftFeaturesPopupFeaturePrice";
import SqftFeaturesPopupFeatureDeleteButton from "./sqftFeaturesPopupFeatureDeleteButton";
import SqftFeaturesPopupFeatureEyeball from "./sqftFeaturesPopupFeatureEyeball";
import FeatureName from "../../visComponents/featureName";
import {SQFT_FEATURES} from "../../sqft/constants";
import MaterialsWizardWarningCheckMark from "../../qkbPages/materialsWizard/materialsWizardWarningCheckMark";
import {findSlabConflict} from "../../sqft/components/canvas/core/slab/slabHelper";
import {canOpenWizardConflictPopup} from "../../../misc/conflictPopups";

const SqftFeaturesPopupFeature = (props) => {

  const { parentsList, parentsLists, setParentsLists, parentKey, sqftFeature, activeTheme, rebuildQuoteLists,
    wizardConflictingSteps, canOpenWizardConflict, sqftSlabConflicts, activeQuoteIndex } = props;

  const {disabled, feature} = sqftFeature;

  const editButtonColor = disabled && feature
    ? COLOR_THEMES[activeTheme].primary
    : feature
      ? COLOR_THEMES[activeTheme].primary
      : COLORS.red
  const shouldDisplayEyeball = parentKey !== SQFT_FEATURES.slabs && sqftFeature.shouldShowEyeBall;
  const shouldDisplayEditButton = parentKey !== SQFT_FEATURES.edges
    && parentKey !== SQFT_FEATURES.slabs
    && parentKey !== SQFT_FEATURES.oversized;

  const isActiveQuote = parentsList.quoteIndex === activeQuoteIndex;
  const hasSlabConflict = findSlabConflict(sqftFeature, sqftSlabConflicts);
  const hasWizardConflict = canOpenWizardConflict && wizardConflictingSteps.length && sqftFeature.fromWizardGroupId && wizardConflictingSteps.some(step => {
    return step.wizardGroupId === sqftFeature.fromWizardGroupId;
  })
  const hasConflict = isActiveQuote && (hasWizardConflict || hasSlabConflict);

  return (
    <li className={"sqft-popup__feature bold" + (disabled ? " sqft-popup__feature--disabled" : "")
    + (feature ? " sqft-popup__feature--added" : "")} data-feature={!!feature}>
      { shouldDisplayEyeball
        ? <SqftFeaturesPopupFeatureEyeball editButtonColor={editButtonColor}
                                           sqftFeature={sqftFeature}/>
        : null
      }
      { shouldDisplayEditButton
        ? <SqftFeaturesPopupFeatureDropdown editButtonColor={editButtonColor}
                                            parentsList={parentsList}
                                            parentsLists={parentsLists}
                                            setParentsLists={setParentsLists}
                                            sqftFeature={sqftFeature}
                                            rebuildQuoteLists={rebuildQuoteLists}/>
        : <div className={"sqft-popup__feature-name" + (hasConflict ? " message-system-text-red" : "")}>
          {feature ? <FeatureName feature={feature} maxLength={35}/> : null}
        </div>
      }

      {hasConflict ? (
        <div className="relative inline-block group u-pr-05">
          <MaterialsWizardWarningCheckMark className="!static"/>
          <div
            className="group-hover:opacity-100 group-hover:visible absolute opacity-0 invisible transition-all
            rounded-lg bg-red-600 px-4 py-2 text-white shadow-lg w-[320px] right-[-42px] mt-4 z-10
           after:content-[''] after:absolute after:-top-[10px] after:right-14 after:h-0 after:w-0 after:h-0
           after:border-l-[10px] after:border-r-[10px] after:border-b-[10px] after:border-solid
           after:border-l-transparent after:border-r-transparent after:border-b-red-600"
          >
            <p className="font--14 m-0">
              There is a conflict {sqftSlabConflicts.length ? "in slab mode " : ""}that needs to be resolved before adding to quote.
            </p>
          </div>
        </div>
      ) : null}
      <SqftFeaturesPopupFeaturePrice sqftFeature={sqftFeature} parentsList={parentsList}/>
      {feature ? <SqftFeaturesPopupFeatureDeleteButton parentsList={parentsList}
                                                       parentsLists={parentsLists}
                                                       setParentsLists={setParentsLists}
                                                       sqftFeature={sqftFeature}/> : null}
    </li>
  )
};

SqftFeaturesPopupFeature.propTypes = {
  parentsList: PropTypes.object.isRequired,
  parentsLists: PropTypes.array.isRequired,
  setParentsLists: PropTypes.func.isRequired,
  parentKey: PropTypes.string.isRequired,
  sqftFeature: PropTypes.object.isRequired,
  rebuildQuoteLists: PropTypes.func.isRequired,
}

const mapStateToProps = (store) => {
  const {activeTheme} = store.serverState;
  const {wizardConflictingSteps} = store.wizardState;
  const {sqftSlabConflicts} = store.sqftSlabState;
  const {activeQuoteIndex} = store.quotesState;
  return {
    activeTheme,
    wizardConflictingSteps,
    canOpenWizardConflict: canOpenWizardConflictPopup(store),
    sqftSlabConflicts,
    activeQuoteIndex,
  };
};
const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(SqftFeaturesPopupFeature)
